'use strict';

var _availabilityChecks;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var availability = require('./availability');
var dateUtil = require('./dateUtil');

var availabilityChecks = (_availabilityChecks = {}, _defineProperty(_availabilityChecks, availability.INDIA_ONLY, function (reseller) {
  return reseller && reseller.market && /IN$/.test(reseller.market);
}), _defineProperty(_availabilityChecks, availability.NOT_INDIA, function (reseller) {
  return reseller && reseller.market && !/IN$/.test(reseller.market);
}), _availabilityChecks);

// Assuming dates are `YYYY-MM-DD` formatted, then they can be directly
// compared as strings.

var isOnOrAfterStartDate = function isOnOrAfterStartDate(promotion) {
  return !!promotion && (!promotion.startDate || dateUtil.isValid(promotion.startDate) && dateUtil.today() >= promotion.startDate);
};

var isOnOrBeforeEndDate = function isOnOrBeforeEndDate(promotion) {
  return !!promotion && (!promotion.endDate || dateUtil.isValid(promotion.endDate) && dateUtil.today() <= promotion.endDate);
};

module.exports = {
  isOnOrAfterStartDate: isOnOrAfterStartDate,
  isOnOrBeforeEndDate: isOnOrBeforeEndDate,

  isActive: function isActive(promotion) {
    return !!promotion && promotion.isActive !== false && isOnOrAfterStartDate(promotion) && isOnOrBeforeEndDate(promotion);
  },

  isAvailable: function isAvailable(promotion, reseller) {
    if (!promotion) {
      return false;
    } else if (promotion.availability == null) {
      return true;
    }

    var availabilityCheck = availabilityChecks[promotion.availability];

    return availabilityCheck ? availabilityCheck(reseller) : false;
  },

  isAvailableToCustomer: function isAvailableToCustomer(promotion, customer) {
    if (!promotion) {
      return false;
    } else if (promotion.customerAvailability == null) {
      return true;
    } else if (typeof promotion.customerAvailability !== 'function' || customer == null) {
      return false;
    }

    return promotion.customerAvailability(customer);
  }
};